import React from 'react';
import i18n from '../../i18n/i18n.js';
import ProductListItem from '../ProductListItem/ProductListItem.js';

class RecommendedProducts extends React.Component {

    fakeProducts = [
        {
            id: 1,
            product: 'EASY',
            price_original: '24 999 Ft',
            price: '7 999 Ft',
            sale: 1,
            image: 'assets/images/demo/fav.png',
            fav: 1,
            url: 'xyz',
        },
        {
            id: 2,
            product: 'EASY',
            price_original: '19 999 Ft',
            price: '19 999 Ft',
            sale: 0,
            image: 'assets/images/demo/fav.png',
            fav: 1,
            url: 'xyz',
        },
        {
            id: 3,
            product: 'FLASH',
            price_original: '24 999 Ft',
            price: '7 999 Ft',
            sale: 1,
            image: 'assets/images/demo/fav.png',
            fav: 1,
            url: 'xyz',
        },
        {
            id: 4,
            product: 'FLASH',
            price_original: '19 999 Ft',
            price: '19 999 Ft',
            sale: 0,
            image: 'assets/images/demo/fav.png',
            fav: 1,
            url: 'xyz',
        },
    ];

    title = '';

    constructor(props) {
        super(props);

        this.title = (props.title) ? props.title : i18n.t('productsListRecommendedTitle');
    }

    render(){
        return <div className='recommended_products_slider'>
            <div className='title'>{this.title}</div>
            <div className='slider-outer'>
                <div className='slider-inner'>
                {this.fakeProducts.map(product => <ProductListItem key={`${product.id}`} product={product} />)}
                </div>
            </div>
        </div>;
    }
}

export default RecommendedProducts;